import { extent } from 'd3-array';

export default function useExtent(iterable: any, accessor: any) {
  return extent(iterable, accessor);
}
